import React, { useState, useEffect } from "react";

import { trackPromise } from "react-promise-tracker";

import services from "../../services";

import {
  detalhesUsuario,
  editarUsuario,
  listarPermissoes,
} from "../../services/http/usuariosService";

import {
  Avatar,
  Divider,
  Form,
  Input,
  Button,
  Row,
  Col,
  Checkbox,
  message,
} from "antd";

import Header from "../../components/Header";

import "./styles.scss";

const PerfilUsuairo = () => {
  const { IdUser, IsAdmin } = services.storage.getUser();
  const [form] = Form.useForm();
  const [usuario, setUsuario] = useState({});
  const [permissoes, setPermissoes] = useState([]);
  const [pemissoesUsuario, setPermissoesUsuario] = useState([{}]);
  const [permissoesDetalhe, setPermissoesDetalhe] = useState(false);

  const showIniciais = (nome) => {
    let nomecompleto = nome.replace(".", " "); // Remove os de,da, dos,das.
    var iniciais = nomecompleto.match(/\b(\w)/gi); // Iniciais de cada parte do nome.
    var sobrenomes = iniciais.splice(0, iniciais.length).join("").toUpperCase(); // Iniciais
    return sobrenomes;
  };

  useEffect(() => {
    form.resetFields();
    buscarDetalhes(IdUser);
  }, [IdUser]);

  useEffect(() => {
    buscarDetalhes(IdUser);
  }, [IdUser]);

  useEffect(() => {
    listaPermissoes();
    iniciarValoresForm();
    setPermissoesDetalhe(false);
    montarPermissoes();
  }, [permissoesDetalhe]);

  const buscarDetalhes = (id) => {
    trackPromise(
      detalhesUsuario(id)
        .then((res) => {
          if (!res.fail && res.data) {
            setUsuario(res.data);
            setPermissoesDetalhe(true);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const atualizarUsuario = (values, usuarioPermissoes) => {
    let data = {
      id: usuario.id,
      email: values.email,
      login: values.login,
      nivelAcesso: values.nivelAcesso,
    };

    let arrayPermissoes = [];

    usuarioPermissoes.forEach((element) => {
      if (element.id != "todos" && element.checked) {
        arrayPermissoes.push({
          id: element.id,
          permissao: element.permissao,
        });
      }
    });

    data.permissoes = arrayPermissoes;

    trackPromise(
      editarUsuario(data)
        .then((res) => {
          if (!res.fail) {
            message.success("Usuario atualizado com sucesso");
            buscarDetalhes(IdUser);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const listaPermissoes = () => {
    trackPromise(
      listarPermissoes()
        .then((res) => {
          if (!res.fail && res.data) {
            setPermissoes(res.data);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const montarPermissoes = () => {
    let novaListaPermissoes = permissoes.map((element) => {
      let permSelecionada = usuario.permissoes.find(
        (p) => p.permissao === element.permissao
      );

      return {
        id: element.id,
        permissao: element.permissao,
        checked: permSelecionada ? true : false,
      };
    });
    setPermissoesUsuario(novaListaPermissoes);
  };

  const iniciarValoresForm = () => {
    if (usuario?.id != null) {
      form.setFieldsValue({
        nome: usuario.nome,
        login: usuario.login,
        email: usuario.email,
        nivelAcesso: usuario.nivelAcesso,
      });
    }
  };

  const onSubmit = (values) => {
    atualizarUsuario(values, pemissoesUsuario);
  };

  const handleCheckedPermissoes = (item, checked) => {
    if (item == "todos") {
      var arrayMap = pemissoesUsuario.map((item) => {
        return {
          id: item.id,
          permissao: item.permissao,
          checked: checked,
        };
      });
      setPermissoesUsuario(arrayMap);
    } else {
      let indexPermissao = pemissoesUsuario.findIndex((p) => p.id == item);

      if (indexPermissao >= 0) {
        pemissoesUsuario[indexPermissao].checked = checked;
        setPermissoesUsuario(pemissoesUsuario);
      }
    }
  };

  const showAvatar = () => {
    if (usuario.login) {
      return (
        <div className="row perfil-usuario-avatar">
          <Avatar style={{ background: "#0042DD", color: "#FFFFFF" }}>
            {showIniciais(usuario.login)}
          </Avatar>
          <span className="span-nome-login"> {usuario.login} </span>
        </div>
      );
    }
  };

  return (
    <div className="row">
      <Header style={{ marginBottom: "2rem" }} mostrarPesquisar={false} />
      <div className="col-lg-6 col-md-6 col-sm-6" style={{ marginLeft: "25%" }}>
        {showAvatar()}

        <div className="row">
          <Divider style={{ background: "#9E9E9E" }} />
        </div>

        <div className="row">
          <span className="span-title">Dados Cadastrais</span>
        </div>

        <Form form={form} layout="vertical" onFinish={onSubmit}>
          <div className="row">
            <div className="col-lg-5 col-md-12 col-sm-12 p-0">
              <Form.Item
                disabled
                className="label-usuario"
                label="Login"
                name="login"
              >
                <Input disabled={true} className="input-usuario" />
              </Form.Item>
            </div>

            <div className="col-lg-6 col-md-12 col-sm-12 ml-lg-5">
              <Form.Item className="label-usuario" label="E-mail" name="email">
                <Input disabled={true} className="input-usuario" />
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-5 col-md-12 col-sm-12 p-0">
              <Form.Item
                disabled
                className="label-usuario"
                label="Nivel de acesso"
                name="nivelAcesso"
              >
                <Input disabled={true} className="input-usuario" />
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <span className="span-title mb-3">Permissões de visualização</span>
          </div>
          <div className="col-md-9 divOrdenarUsuarios list-container-horizontal">
            {IsAdmin == "False"
              ? pemissoesUsuario
                  .filter((x) => x.checked === true)
                  .map((item, index) => {
                    return (
                      <div key={index} span={6}>
                        <div className="m-0 p-0 ordenarUsuario">
                          <Checkbox
                            disabled={true}
                            defaultChecked={item.checked}
                            onChange={(e) =>
                              handleCheckedPermissoes(
                                `${item.id}`,
                                e.target.checked
                              )
                            }
                          >
                            <span className="span-quebra-de-linha">
                              {item.permissao}
                            </span>
                          </Checkbox>
                        </div>
                      </div>
                    );
                  })
              : pemissoesUsuario.map((item, index) => {
                  return (
                    <div key={index} span={6}>
                      <div className="m-0 p-0 ordenarUsuario">
                        <Checkbox
                          defaultChecked={item.checked}
                          onChange={(e) =>
                            handleCheckedPermissoes(
                              `${item.id}`,
                              e.target.checked
                            )
                          }
                        >
                          <span className="span-quebra-de-linha">
                            {item.permissao}
                          </span>
                        </Checkbox>
                      </div>
                    </div>
                  );
                })}
          </div>
          {IsAdmin == "True" && (
            <div className="row div-button">
              <Form.Item>
                <button
                  type="primary"
                  style={{ color: "#ffff !important" }}
                  htmlType="submit"
                  className="button-usuario"
                >
                  APLICAR
                </button>
              </Form.Item>
            </div>
          )}
        </Form>
      </div>
    </div>
  );
};

export default PerfilUsuairo;
